/* Deniz Doğal Taş — panel bağlantısı.
   Test motorunu (deniz-test-motor.js) HİÇ DEĞİŞTİRMEDEN:
   1) Sonuç ekranı (.dz-sonuc) çıkınca test kaydını panele POST eder (store=deniz).
   2) Öneri taşı sepete eklenince sepeti "Deniz Testi: DZ-XXXX" ile etiketler
      (motorun deniz:sepet-guncellendi event'ini dinler; /cart/update.js ile).
   Panel: https://www.osmanliyonetim.com */
(function () {
  'use strict';
  var API = 'https://www.osmanliyonetim.com/wp-json/odt/v1';
  var TEST = window.DENIZ_TEST_ID || (document.querySelector('[data-deniz-test]') || {}).getAttribute
    ? (document.querySelector('[data-deniz-test]') || document.body).getAttribute('data-deniz-test') : '';
  if (!TEST) return;

  var sonKod = null;

  function yeniKod() {
    var s = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789', r = '';
    for (var i = 0; i < 6; i++) r += s[Math.floor(Math.random() * s.length)];
    return 'DZ-' + r;
  }

  function metin(sel, kok) {
    var e = (kok || document).querySelector(sel);
    return e ? (e.textContent || '').trim() : '';
  }

  // Sonuç ekranından özet çıkar (başlık + rozetler + ölçümler + öneri ürünler)
  function ozetTopla(kutu) {
    var oz = { rozetler: [], olcumler: [], urunler: [] };
    kutu.querySelectorAll('.dz-oz-rozet').forEach(function (r) {
      oz.rozetler.push({
        etiket: metin('.dz-oz-etiket', r),
        deger: metin('.dz-oz-deger', r)
      });
    });
    kutu.querySelectorAll('.dz-olcum').forEach(function (o) {
      oz.olcumler.push(metin('.dz-olcum-ust span', o) + ' ' + metin('.dz-olcum-ust b', o));
    });
    kutu.querySelectorAll('.dz-urunler a, .dz-urun-kart').forEach(function (u) {
      var t = (u.getAttribute('data-baslik') || u.textContent || '').trim().slice(0, 80);
      if (t) oz.urunler.push(t);
    });
    return oz;
  }

  function kaydet(kutu) {
    sonKod = yeniKod();
    var baslik = metin('.dz-sonuc-baslik', kutu) || metin('.dz-sonuc-alt', kutu);
    var kod = sonKod;
    // Öneri ürünler ~340ms sonra basılıyor → önce ürünsüz yaz, sonra güncelle
    function gonder() {
      fetch(API + '/deniz/kaydet', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ store: 'deniz', test: TEST, kod: kod, baslik: baslik, ozet: ozetTopla(kutu) })
      }).catch(function () {});
    }
    gonder();
    setTimeout(gonder, 900); // ürünler yüklendikten sonra tekrar (kod aynı → günceller)
  }

  // Sonuç ekranı (.dz-sonuc) DOM'a girince yakala
  function izle() {
    var kok = document.querySelector('.deniz-test-kok') || document.body;
    var mo = new MutationObserver(function () {
      var s = document.querySelector('.dz-sonuc');
      if (s && !s.__odtKaydedildi) { s.__odtKaydedildi = true; kaydet(s); }
    });
    mo.observe(kok, { childList: true, subtree: true });
    // Sayfa açılışında zaten sonuç varsa
    var v = document.querySelector('.dz-sonuc');
    if (v && !v.__odtKaydedildi) { v.__odtKaydedildi = true; kaydet(v); }
  }

  // Sepete ekleme sonrası: motorun event'ini dinle, sepeti test koduyla etiketle
  document.addEventListener('deniz:sepet-guncellendi', function () {
    if (!sonKod) return;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { 'Deniz Testi': sonKod } })
    }).catch(function () {});
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', izle);
  } else { izle(); }
})();
